var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 108,
    viewBox: "0 0 90 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.45 58.7087L7.45 107.309C5.9 108.248 4.01 108.227 2.48 107.265C0.94 106.293 0 104.522 0 102.6V5.39999C0 3.47759 0.94 1.7064 2.48 0.734398C3.26 0.248398 4.13 0 5 0C5.84 0 6.69 0.226807 7.45 0.6912L87.45 49.2911C89.02 50.2523 90 52.0451 90 53.9999C90 55.9547 89.02 57.7475 87.45 58.7087Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtn);
export default __webpack_public_path__ + "static/media/playBtn.a4acf9b1e0eca93fd7f064447c212804.svg";
export { ForwardRef as ReactComponent };